import './menu.css';
import btnModeLight from './light_mode.png'
import btnModeDark from './dark_mode.png'
import logo from './logo80x80.webp'
import { useState } from "react";
import { useTheme } from "../../theme-context";
import { useRef } from "react";

export default function Menu({ onSelect, activePage }) {

    const { theme, toggleTheme } = useTheme();
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);
    const isMobile = window.innerWidth <= 768;

    const btnModeAccion = (e) => {
        if (isMobile) {
            toggleTheme()
            setTimeout(() => {
                handleClick(e);
            }, 1000);
        } else {
            toggleTheme()
        }
    };

    const handleClick = (e) => {
        e.preventDefault();
        const menu = menuRef.current;

        if (menu) {
            menu.classList.add("slideUp");
            setOpen(false);
            setTimeout(() => {
                menu.classList.remove("slideUp");
            }, 1000);
        }
    };

    const handleSocialClick = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <div ref={menuRef} className="menu">
            <header id="header">

                <div className="logo" onClick={(e) => { handleClick(e); onSelect("/"); }}>
                    <img src={logo} alt="logo" />
                </div>

                <button
                    className={`hamburger ${open ? "active" : ""}`}
                    onClick={() => setOpen(!open)}
                    aria-label="Menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <nav className={`nav-links ${open ? "show" : ""}`}>
                    <div id="links">
                        <li> <a href="#!" onClick={(e) => { handleClick(e); onSelect("about"); }} className={activePage === "about" ? "active" : ""} >About</a></li>
                        <li><a href="#!" onClick={(e) => { handleClick(e); onSelect("skills"); }} className={activePage === "skills" ? "active" : ""} >Skills</a></li>
                        <li><a href="#!" onClick={(e) => { handleClick(e); onSelect("portfolio"); }} className={activePage === "portfolio" ? "active" : ""} >Portfolio</a></li>
                        <li><a href="#!" onClick={(e) => { handleClick(e); onSelect("blog"); }} className={activePage === "blog" ? "active" : ""} >Blog</a></li>
                        <li><a href="#!" onClick={(e) => { handleClick(e); onSelect("contacts"); }} className={activePage === "contacts" ? "active" : ""} >Contacts</a></li>
                    </div>

                    <div className="social">
                        <ul>
                            <li className="linkedin" onClick={() => handleSocialClick("https://linkedin.com/in/rbeaujon/")}>
                                <a href="https://linkedin.com/in/rbeaujon/" target="_blank" rel="noreferrer">
                                    <img src="./dist/assets/icons/linkedIn2.png" alt="LinkedIn - Ricardo Beaujon" />
                                </a>
                            </li>
                            <li className="email" onClick={() => handleSocialClick("mailto:rbeaujon77@gmail.com")}>
                                <a href="mailto:rbeaujon77@gmail.com" target="_blank" rel="noreferrer">
                                    <img src="./dist/assets/icons/gmail.png" alt="Email" />
                                </a>
                            </li>
                            <li className="instagram" onClick={() => handleSocialClick("https://www.instagram.com/rbeaujon/")}>
                                <a href="https://www.instagram.com/rbeaujon/" target="_blank" rel="noreferrer">
                                    <img src="./dist/assets/icons/instagram.png" alt="Instagram" />
                                </a>
                            </li>
                            <li className="facebook" onClick={() => handleSocialClick("https://www.facebook.com/rbeaujon")}>
                                <a href="https://www.facebook.com/rbeaujon" target="_blank" rel="noreferrer">
                                    <img src="./dist/assets/icons/facebook2.png" alt="Facebook" />
                                </a>
                            </li>
                            <li className="whatsapp" onClick={() => handleSocialClick("https://wa.me/+37253560174")}>
                                <a href="https://wa.me/+37253560174" target="_blank" rel="noreferrer">
                                    <img src="./dist/assets/icons/ws.png" alt="WhatsApp" />
                                </a>
                            </li>
                            <li className="github" onClick={() => handleSocialClick("https://github.com/rbeaujon")}>
                                <a href="https://github.com/rbeaujon" target="_blank" rel="noreferrer">
                                    <img src="./dist/assets/icons/github.png" alt="GitHub" />
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="btn-mode" onClick={(e) => btnModeAccion(e)}>
                        <div className="toggle-circle">
                            {theme === "light" ? <img src={btnModeDark} alt="dark mode" /> : <img src={btnModeLight} alt="light mode" />}
                        </div>
                        <span className="toggle-text">
                            {theme === "light" ? "" : ""}
                        </span>
                    </div>
                </nav>

            </header>

        </div>
    );
} 